import React from 'react';

// List of counties that may need overrides for lat/lng/zoom when clicked due to odd shape or size  (need to be converted to FIPS if used)
// const vpOverrides = [ (Dare, NC), (Oslow, NC), (Ottawa, OH), (Jefferson, NY) ];



export const cityoverrides = ['24510', '51760', '51600', '51620', '51770'];


export const stateFIPS = {
  '11': 'DC',
  '10': 'DE',
  '24': 'MD',
  '34': 'NJ',
  '36': 'NY',
  '42': 'PA',
  '51': 'VA',
  '54': 'WV',
  '37': 'NC',
  '45': 'SC',
  '39': 'OH',
  '18': 'IN',
  '17': 'IL',
  '26': 'MI',
  '55': 'WI',
  '27': 'MN'
};



// List of states that we gather data for
export const stateNames = 'DC, DE, MD, NJ, NY, PA, VA, WV, NC, SC, OH, IN, IL, MI, WI, MN';



// Set up data for attributeOptions
let startYear = 1981;
let endYear = new Date().getFullYear();
let currMonth = new Date().getMonth();
let params = {
  sdate: startYear,
  edate: endYear,
  grid: 'prism',
  state: stateNames
};



// Themes can be added, removed,and altered by editing this object
// Available attributes for the themes can be found below
// Current initial map setting is for the first attribute of the first theme
export const themeGroupings = {
  'Coastal Hazards': [
    'Coastal Flood',
    'High Surf',
    'Rip Current',
    'Storm Surge/Tide',
  ],
  'Extreme Rainfall/Flooding': [
    'hvypcpn1',
    'Coastal Flood',
    'hvypcpn2',
    'Flash Flood',
    'Flood',
    'Heavy Rain',
    'Lakeshore Flood',
    'ttlpcpnspring',
    'ttlpcpnsummer',
    'ttlpcpnfall',
    'ttlpcpnwinter',
    'ttlpcpnannual'
  ],
  'Fog': [
    'Dense Fog',
  ],
  'Great Lakes Hazards': [
    'Lake-Effect Snow',
    'Lakeshore Flood',
  ],
  'Severe Weather': [
    'Flash Flood',
    'Hail',
    'Heavy Rain',
    'High Wind',
    'Strong Wind',
    'Thunderstorm Wind',
    'Tornado'
  ],
  'Tropical Storms/Hurricanes': [
    'Hurricane',
    'Tropical Storm',
  ],
  'Extreme Heat': [
    'cntgt90',
    'cntgt95',
    'cntgt100',
    'Excessive Heat',
    'Heat',
    'maxtemp',
  ],
  'Wildfire': [
    'Wildfire'
  ],
  'Winter Weather': [
    'Blizzard', 
    'Cold/Wind Chill',
    'cntlt0',
    // 'cntlt20',
    'cntlt32',
    'Extreme Cold/Wind Chill',
    'Frost/Freeze',
    'Heavy Snow',
    'Ice Storm',
    'mintemp',
    'Sleet',
    'Winter Storm',
    'Winter Weather'
  ]
};



// List of hazards for the tool
// To add, edit, or remove available hazard options for the tool just change this list
// Be sure to also alter the themeGroupings above with any changes
export const hazardAttrs = [
  'Blizzard', 
  'Coastal Flood',
  'Cold/Wind Chill',
  'Dense Fog',
  'Excessive Heat',
  'Extreme Cold/Wind Chill',
  'Flood',
  'Flash Flood',
  'Frost/Freeze',
  'Hail',
  'Heat',
  'Heavy Rain',
  'Heavy Snow',
  'High Surf',
  'High Wind',
  'Hurricane',
  'Ice Storm',
  'Lake-Effect Snow',
  'Lakeshore Flood',
  'Rip Current',
  'Sleet',
  'Storm Surge/Tide',
  'Strong Wind',
  'Thunderstorm Wind',
  'Tornado',
  'Tropical Storm',
  'Wildfire',
  'Winter Storm',
  'Winter Weather'
];



// Object used in many parts of the program
// To add, edit, or remove attribute options for the tool just change this object
// Be sure to also alter the themeGroupings above with any changes
export const attributeOptions = {
  'maxtemp': {
    'name': 'Summer Maximum Temperature',
    'units': '°F',
    'text': 'maximum temperatures ',
    'precip': false,
    'winter': false,
    'title': 'Average Summer Maximum Temperature',
    'month': '-08',
    params: {
      ...params,
      sdate: `${startYear}-08`,
      edate: `${currMonth < 8 ? endYear - 1 : endYear}-08`,
      elems: [{
        name: 'maxt',
        interval: [1,0],
        duration: 3,
        reduce: 'mean'
      }]
    },
  },
  'mintemp': {
    'name': 'Winter Minimum Temperature',
    'units': '°F',
    'text': 'minimum temperatures ',
    'precip': false,
    'winter': true,
    'title': 'Average Winter Minimum Temperature',
    'month': '-02',
    'dayUnits': false,
    params: {
      ...params,
      sdate: `${startYear}-02`,
      edate: `${currMonth < 2 ? endYear - 1 : endYear}-02`,
      elems: [{
        name: 'mint',
        interval: [1,0],
        duration: 3,
        reduce: 'mean'
      }]
    },
  },
  'cntgt90': {
    'name': 'Days w/ High >90°F',
    'units': ' days',
    'text': 'number of days with high temperatures over 90°F ',
    'precip': false,
    'winter': false,
    'title': 'Number of Days with Maximum Temperature Over 90°F',
    'month': '',
    'dayUnits': true,
    params: {
      ...params,
      elems: [{
        name: 'maxt',
        interval: [1],
        duration: 1,
        reduce: 'cnt_gt_90'
      }]
    },  
  },
  'cntgt95': {
    'name': 'Days w/ High >95°F',
    'units': ' days',
    'text': 'number of days with high temperatures over 95°F ',
    'precip': false,
    'winter': false,
    'title': 'Number of Days with Maximum Temperature Over 95°F',
    'month': '',
    'dayUnits': true,
    params: {
      ...params,
      elems: [{
        name: 'maxt',
        interval: [1],
        duration: 1,
        reduce: 'cnt_gt_95'
      }]
    }, 
  },
  'cntgt100': {
    'name': 'Days w/ High >100°F',
    'units': ' days',
    'text': 'number of days with high temperatures over 100°F ',
    'precip': false,
    'winter': false,
    'title': 'Number of Days with Maximum Temperature Over 100°F',
    'month': '',
    'dayUnits': true,
    params: {
      ...params,
      elems: [{
        name: 'maxt',
        interval: [1],
        duration: 1,
        reduce: 'cnt_gt_100'
      }]
    }, 
  },
  'cntlt0': {
    'name': 'Days w/ Low <0°F',
    'units': ' days',
    'text': 'number of days with low temperatures under 0°F ',
    'precip': false,
    'winter': true,
    'title': 'Number of Days with Minimum Temperature Below 0°F',
    'month': '-07',
    'dayUnits': true,
    params: {
      ...params,
      sdate: `${startYear}-07`,
      edate: `${currMonth < 7 ? endYear - 1 : endYear}-07`,
      elems: [{
        name: 'mint',
        interval: [1,0],
        duration: 12,
        reduce: 'cnt_lt_0'
      }]
    },  
  },
  // 'cntlt20': {
  //   'name': 'Days w/ Low <20°F',
  //   'units': ' days',
  //   'text': 'number of days with low temperatures under 20°F ',
  //   'precip': false,
  //   'winter': true,
  //   'title': 'Number of Days with Minimum Temperature Below 20°F',
  //   'month': '-07',
  //   'dayUnits': true,
  //   params: {
  //     ...params,
  //     sdate: `${startYear}-07`,
  //     edate: `${currMonth < 7 ? endYear - 1 : endYear}-07`,
  //     elems: [{
  //       name: 'mint',
  //       interval: [1,0],
  //       duration: 12,
  //       reduce: 'cnt_lt_20'
  //     }]
  //   },  
  // },
  'cntlt32': {
    'name': 'Days w/ High <32°F',
    'units': ' days',
    'text': 'number of days with high temperatures under 32°F ',
    'precip': false,
    'winter': true,
    'title': 'Number of Days with Maximum Temperature Below 32°F',
    'month': '-07',
    'dayUnits': true,
    params: {
      ...params,
      sdate: `${startYear}-07`,
      edate: `${currMonth < 7 ? endYear - 1 : endYear}-07`,
      elems: [{
        name: 'maxt',
        interval: [1,0],
        duration: 12,
        reduce: 'cnt_lt_32'
      }]
    },  
  },
  'ttlpcpnspring': {
    'name': 'Total Spring Precipitation',
    'units': ' inches',
    'text': 'total spring precipitation ',
    'precip': true,
    'winter': false,
    'title': 'Total Spring Precipitation',
    'month': '-05',
    'dayUnits': false,
    params: {
      ...params,
      sdate: `${startYear}-05`,
      edate: `${currMonth < 2 ? endYear - 1 : endYear}-05`,
      elems: [{
        name: 'pcpn',
        interval: [1,0],
        duration: 3,
        reduce: 'sum'
      }]
    },   
  },
  'ttlpcpnsummer': {
    'name': 'Total Summer Precipitation',
    'units': ' inches',
    'text': 'total summer precipitation ',
    'precip': true,
    'winter': false,
    'title': 'Total Summer Precipitation',
    'month': '-08',
    'dayUnits': false,
    params: {
      ...params,
      sdate: `${startYear}-08`,
      edate: `${currMonth < 2 ? endYear - 1 : endYear}-08`,
      elems: [{
        name: 'pcpn',
        interval: [1,0],
        duration: 3,
        reduce: 'sum'
      }]
    },   
  },
  'ttlpcpnfall': {
    'name': 'Total Fall Precipitation',
    'units': ' inches',
    'text': 'total fall precipitation ',
    'precip': true,
    'winter': false,
    'title': 'Total Fall Precipitation',
    'month': '-11',
    'dayUnits': false,
    params: {
      ...params,
      sdate: `${startYear}-11`,
      edate: `${currMonth < 2 ? endYear - 1 : endYear}-11`,
      elems: [{
        name: 'pcpn',
        interval: [1,0],
        duration: 3,
        reduce: 'sum'
      }]
    },   
  },
  'ttlpcpnwinter': {
    'name': 'Total Winter Precipitation',
    'units': ' inches',
    'text': 'total winter precipitation ',
    'precip': true,
    'winter': true,
    'title': 'Total Winter Precipitation',
    'month': '-02',
    'dayUnits': false,
    params: {
      ...params,
      sdate: `${startYear}-02`,
      edate: `${currMonth < 2 ? endYear - 1 : endYear}-02`,
      elems: [{
        name: 'pcpn',
        interval: [1,0],
        duration: 3,
        reduce: 'sum'
      }]
    },  
  },
  'ttlpcpnannual': {
    'name': 'Total Annual Precipitation',
    'units': ' inches',
    'text': 'total annual precipitation ',
    'precip': true,
    'winter': false,
    'title': 'Total Annual Precipitation',
    'month': '',
    'dayUnits': false,
    params: {
      ...params,
      elems: [{
        name: 'pcpn',
        interval: [1],
        duration: 1,
        reduce: 'sum'
      }]
    },  
  },
  'hvypcpn1': {
    'name': 'Days w/ Pcpn >1in',
    'units': ' days',
    'text': 'number of days with more than 1 inch of precipitation ',
    'precip': true,
    'winter': false,
    'title': 'Number of Days with Precipitation >1 Inches',
    'month': '',
    'dayUnits': true,
    params: {
      ...params,
      elems: [{
        name: 'pcpn',
        interval: [1],
        duration: 1,
        reduce: 'cnt_gt_1'
      }]
    },  
  },
  'hvypcpn2': {
    'name': 'Days w/ Pcpn >2in',
    'units': ' days',
    'text': 'number of days with more than 2 inch of precipitation ',
    'precip': true,
    'winter': false,
    'title': 'Number of Days with Precipitation >2 Inches',
    'month': '',
    'dayUnits': true,
    params: {
      ...params,
      elems: [{
        name: 'pcpn',
        interval: [1],
        duration: 1,
        reduce: 'cnt_gt_2'
      }]
    },  
  },
  'runmaxpcpnlt01': {
    'name': 'Max Consecutive Days w/ <0.01in Pcpn',
    'units': ' days',
    'text': 'maximum number of consecutive days with less than 0.01 inch of precipitation ',
    'precip': true,
    'winter': false,
    'title': 'Maximum Number of Consecutive Days with Precipitation <0.01 Inches',
    'month': '-12-31',
    'dayUnits': true,
    params: {
      ...params,
      sdate: `${startYear}-12-31`,
      edate: `${currMonth < 7 ? endYear - 1 : endYear}-12-31`,
      elems: [{
        name: 'pcpn',
        interval: [1,0,0],
        duration: 'ytd',
        reduce: 'runmax_lt_0.01'
      }]
    },  
  }
};



// Used to retrieve necessary text from the attributeOptions object, defined above
export function getAttributeText(mode, option) {
  let attrName, unit, tooltipUnit;

  if (mode) {
    let attr = attributeOptions[option];
    try {
      attrName = attr['title'];
      if (attr['dayUnits']) {
        unit = 'Number of Days';
        tooltipUnit = 'days';
      } else if (option.includes('temp')) {
        unit = 'Temperature (°F)';
        tooltipUnit = '°F';
      } else {
        unit = 'Precipitation (in)';
        tooltipUnit = 'in';
      }
    } catch {
      // Ignore error due to rendering attempts before data is loaded
    }
  } else {
    switch(option) {
    case 'count':
      attrName = 'Total Reported Episodes';
      unit = 'episodes';
      break;
    case 'damageCrops':
      attrName = 'Total Reported Crop Damage';
      unit = '';
      break;
    case 'damageProperty':
      attrName = 'Total Reported Property Damage';
      unit = '';
      break;
    case 'deaths':
      attrName = 'Total Reported Deaths';
      unit = 'deaths';
      break;
    case 'injuries':
      attrName = 'Total Reported Injuries';
      unit = 'injuries';
      break;
    default: break;
    }  
  }

  return {attrName, unit, tooltipUnit};
}



// Utility function to convert numbers to string with comma separated values if necessary
// I.E. 10000 -> "10,000"
export function formatNumber(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}



export const hazardDefinitions = {
  'Blizzard': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-blizzard">blizzard</span>,
    ' is defined as a winter storm which has both sustained 35 miles per hour (mph) winds or frequent gusts of wind along with snow (falling or blowing) that reduces visibility to less than a quarter of a mile for a minimum of three consecutive hours.',
  ],
  'Coastal Flood': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-cfe">coastal flood event</span>,
    ' is defined as a rise in sea level to above normal levels due to high tides, onshore winds, and/or low atmospheric pressure (but not a tropical storm) on land that is adjacent to the ocean or its connected bays and estuaries.',
  ],
  'Cold/Wind Chill': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-cwc">cold/wind chill event</span>,
    ' is defined as a “period of low temperatures or wind chill temperatures reaching or exceeding locally/regionally defined advisory [...] conditions”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="windChill">[1]</a>
  ],
  'Dense Fog': [
    <span key="span-fog">Dense fog</span>,
    ' is defined as fog that has reduced visibility to approximately a quarter of a mile or less.',
  ],
  // "Drought": [
  //   <span style={{fontWeight: "bold"}} key="span-drought">Drought</span>,
  //   " is defined as “a protracted period of deficient precipitation” which causes “adverse impacts on people, animals, or vegetation over a sizeable area”.",
  //   <a href="http://drought.unl.edu/DroughtBasics/WhatisDrought.aspx" target="_blank" rel="noreferrer" key="drought1">[2]</a>,
  //   " Drought declarations are regionally-specific and based on the magnitude of drought in a given place. The magnitude of a drought is determined by the U.S. Drought Monitor.",
  //   <a href="https://droughtmonitor.unl.edu/" target="_blank" rel="noreferrer" key="drought2">[3]</a>
  // ],
  'Excessive Heat': [
    <span style={{fontWeight: 'bold'}} key="span-eh">Excessive heat</span>,
    ' is defined as a combination of high temperatures and high humidity (which together form a heat index) that can impact human health. An excessive heat event is recorded/reported when heat indices “meet or exceed locally/regionally established excessive heat warning thresholds.”',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="exHeat">[4]</a>
  ],
  'Extreme Cold/Wind Chill': [
    'An ',
    <span style={{fontWeight: 'bold'}} key="span-ecwc">extreme cold/wind chill event</span>,
    ' is recorded when “temperatures or wind chill temperatures reach or exceed locally/regionally defined warning criteria”. While this varies regionally, it usually occurs when temperatures reach -35 degrees Fahrenheit or colder.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="extCold">[5]</a>
  ],
  'Flood': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-f">flood event</span>,
    ' is defined as the inundation by water, either pluvial or fluvial, of a normally dry area that has the potential to cause damage.',
  ],
  'Flash Flood': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-ff">flash flood event</span>,
    ' is defined as when a normally dry area experiences a rapid rise of water within a short period of time (minutes to hours) of an intense rainfall event or other precipitating cause (such as a dam failure or ice jam). Flash flooding often “requires immediate action to protect life and property”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="flood">[6]</a>
  ],
  'Frost/Freeze': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-ffe">frost/freeze event</span>,
    ' is defined as when the surface air temperature reaches 32 degrees Fahrenheit or colder, or when ice crystals (frost) form on a surface for long enough that it causes an impact during the local growing season.',
  ],
  'Hail': [
    <span style={{fontWeight: 'bold'}} key="span-hail">Hail</span>,
    ' is defined as a form of frozen precipitation.  A hail event occurs when hail that is three-quarters of an inch falls in a given area, or when smaller hailstones “result in fatalities, injuries, or significant damage”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="hail">[7]</a>
  ],
  'Heat': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-heat">heat event</span>,
    ' is defined as a “period of heat resulting from the combination of high temperatures (above normal) and relative humidity” (also termed a heat index) and is reported/recorded “whenever heat index values meet or exceed locally/regionally established advisory thresholds”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="heat">[8]</a>
  ],
  'Heavy Rain': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-hrain">heavy rain event</span>,
    ' is defined as an “unusually large amount of rain which does not cause a Flash Flood or Flood event, but causes damage”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="hrain">[9]</a>
  ],
  'Heavy Snow': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-hsnow">heavy snow event</span>,
    ' is defined as “snow accumulation meets or exceeds locally/regionally defined 12 and/or 24 hour warning criteria”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="hsnow">[10]</a>,
    ' The particular amount of snowfall for these warning criteria varies by location.',
  ],
  'High Surf': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-hsurf">high surf event</span>,
    ' is defined as the occurrence of large waves, caused by a distant storm or by strong onshore winds, that break either on or near the shore and cause fatality, injury, or other damage.',
  ],
  'High Wind': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-hwind">high wind event</span>,
    ' is defined as sustained winds of 40 miles per hour (mph) or greater for a minimum of one hour or the occurrence of 58 mph winds (or a different windspeed that is defined locally) for any duration. This classification is not used for “severe local storms or winter storm events”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="hwind">[11]</a>
  ],
  'Hurricane': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-">hurricane</span>,
    ' is defined as a tropical storm with sustained surface winds that are 74 mph or greater.',
  ],
  'Ice Storm': [
    'An ',
    <span style={{fontWeight: 'bold'}} key="span-is">ice storm</span>,
    ' is defined as ice accumulations from freezing rain that meet or exceed locally/regionally defined warning criteria, this is typically a quarter to a half an inch. This event does not get reported/recorded if additional forms of precipitation (such as snow) are mixed in with freezing rain.',
  ],
  'Lake-Effect Snow': [
    <span style={{fontWeight: 'bold'}} key="span-lesnow">Lake-effect snow</span>,
    ' is defined as cold air that travels over a comparatively warm, large body of water, resulting in a convective snow band along the leeward side of the body of water.  A lake-effect snow event is recorded when this phenomena causes snow accumulations that meet or exceed locally defined 12 and/or 24 hour warning criteria, typically ~6-8 inches in 12 hours or 8-10 inches in 24 hours.',
  ],
  'Lakeshore Flood': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-lsflood">lakeshore flood event</span>,
    ' is defined as a rise of water above normal levels along a lakeshore due to a “strong, persistent onshore wind and/or atmospheric pressure, resulting in damage [...] fatalities, or injuries”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="lsFlood">[12]</a>
  ],
  'Rip Current': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-rc">rip current</span>,
    ' is defined as “a narrow channel of water that flows away from the beach, through the surf and dissipates beyond the breaking waves”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="rCurrent">[13]</a>,
    ' A rip current can form in any body of water that has breaking waves. Rip current events are reported/recorded only when they necessitate one or more rescues, cause a drowning or near-drowning, or cause any damage to watercraft.',
  ],
  'Sleet': [
    <span style={{fontWeight: 'bold'}} key="span-sleet">Sleet</span>,
    ' is defined as frozen precipitation that becomes frozen while falling.  This is different from freezing rain, which only freezes once it hits a surface. A sleet event occurs when sleet accumulations meet or exceed locally/regionally defined warning criteria, which is typically a half an inch or greater.',
  ],
  'Storm Surge/Tide': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-sst">storm surge/tide event</span>,
    ' is defined as when coastal and lakeshore areas experience a rise in water above normal levels that is “associated with a storm of tropical origin (e.g. hurricane, typhoon, tropical storm, or subtropical storm)” that results in injuries, fatalities, or other damage.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="surge">[14]</a>
  ],
  'Strong Wind': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-swind">strong wind event</span>,
    ' is defined as “non-convective winds” that gust at less than 58 miles per hour (mph) or when sustained winds less than 40 mph result in “fatality, injury, or damage”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="strongWind">[15]</a>,
    ' These mph thresholds may change depending on location.',
  ],
  'Thunderstorm Wind': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-twind">thunderstorm wind event</span>,
    ' is defined as when “winds, arising from convection (occurring within 30 minutes of lightning being observed or detected)” have speeds that are 58 miles per hour (mph) or greater or winds that are less than 58 mph result in fatality, injury, or other damage.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="tWind">[16]</a>
  ],
  'Tornado': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-torn">tornado</span>,
    ' is defined as a “violently rotating column of air [that extends to/from] a cumuliform cloud or underneath a cumuliform cloud  to the ground”.  A tornado should also produce visible effects, “such as dust/dirt rotational markings/swirls, or structural or vegetative damage or disturbance”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="tornado">[17]</a>
  ],
  'Tropical Storm': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-tropStorm">tropical storm</span>,
    ' is defined as a tropical cyclone that has winds between 39 and 73 miles per hour (mph).',
  ],
  'Wildfire': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-wild">wildfire</span>,
    ' is defined as any fire that “consumes the natural fuels and spreads in response to its environment” and “causes one or more fatalities, one or more significant injuries, and/or property damage”.  “In general, forest fires smaller than 100 acres, grassland or rangeland fires smaller than 300 acres, and wildland use fires not actively managed as wildfires” are not reported/recorded as wildfire events.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="wildfire">[18]</a>
  ],
  'Winter Storm': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-winter-storm">winter storm event</span>,
    ' is defined as a “winter weather event that has more than one significant hazard (i.e., heavy snow and blowing snow; snow and ice; snow and sleet; sleet and ice; or snow, sleet and ice) and meets or exceeds locally/regionally defined 12 and/or 24 hour warning criteria for at least one of the precipitation elements”.',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="winterStorm">[19]</a>
  ],
  'Winter Weather': [
    'A ',
    <span style={{fontWeight: 'bold'}} key="span-winter-weather">winter weather event</span>,
    ' is defined as a “winter precipitation event that causes a death, injury, or a significant impact to commerce or transportation, but does not meet locally/regionally defined warning criteria.”',
    <a href="https://www.nws.noaa.gov/directives/sym/pd01016005curr.pdf" target="_blank" rel="noreferrer" key="winterWeather">[20]</a>
  ],
};



export function hmTableInfo() {
  const rows = [['Themes','Hazard Types','Climate Metrics and Projections']];  
  for (const [theme, group] of Object.entries(themeGroupings)) {
    const row = [theme, [], []];
    group.forEach(metric => {
      if (hazardAttrs.includes(metric)) {
        row[1].push(metric);
      } else {
        row[2].push(attributeOptions[metric].name);
      }
    });

    if (row[1].length === 0) row[1].push('No hazard types available for this theme');
    if (row[2].length === 0) row[2].push('No climate data or projections available for this theme');

    rows.push(row);
  }

  return rows;
}